export interface ApiStoreList {
  stores: ApiStoreDetail[];
}

// Stores from Store List request

export interface ApiStoreSummary {
  id: number;
  countryCode: string;
  countryName: string;
  continent: string;
  hostname: string;
  supportedLanguages: ApiStoreLanguage[];
  catalogs: ApiStoreCatalog[];
  isOpenForSale: boolean;
  ffmcenter: number;
  redirectToWorldWide?: number | null;
  countryISOredirect?: string | null;
}

// Store from single store request

export interface ApiStoreDetail extends ApiStoreSummary, Record<string, unknown | null | undefined> {
  details?: ApiStoreDetailDetails;
  storeDefaultLanguageId?: number;
}

// Partial Interfaces

export interface ApiStoreLanguage {
  id: number;
  name: string;
  code: string;
  countryName?: string;
  localCode?: string | null;
  isRTL?: boolean;
}

export interface ApiStoreCatalog {
  id: number;
  type: number;
  identifier?: string;
  storeId?: string | null;
  seocode?: string | null;
}

export interface ApiStoreDetailDetails extends Record<string, unknown | null | undefined> {
  imageBaseUrl?: string;
  staticUrl?: string;
  xmedia?: ApiStoreXmedia;
  locale: ApiStoreDetailLocale;
  alternateLocales: ApiStoreDetailAlternateLocale[];
  location?: ApiStoreDetailLocation;
  timestampBuildVersion?: string;
}

export interface ApiStoreDetailLocation {
  lat: number;
  lng: number;
  zoom: number;
}

export interface ApiStoreDetailLocale extends Record<string, unknown | null | undefined> {
  currencyCode: string; /** Código dentificador de el país/tienda */
  currencyFormatNeg: string; /** Máscara para precios negativos @example "-#,##0.00 € " */
  currencyFormatPos: string; /** Máscara para precios positivos @example "#,##0.00 € " */
  currencyDecimals: number; /** Número de decimales (exponente potencia de 10) @example -2 */
  currencySymbol: string; /** Símbolo de la moneda @example "€" */
  currencydecimalChar: string; /** Carácter del decimal @example "," */
  currencygroupingChar: string; /** Carácter del agrupador @example "." */
}

export interface ApiStoreDetailAlternateLocale extends ApiStoreDetailLocale {
  conversionRate: number; /** Conversión a utilizar para calcular el valor de la moneda local en la moneda alternativa  */
}

export interface ApiStoreXmedia {
  defaultStoreSet: number;
  xmediaFormats: ApiStoreXmediaFormat[];
  xmediaSets: ApiStoreXmediaSet[];
  xmediaSizes: ApiStoreXmediaSize[];
}

export interface ApiStoreXmediaFormat {
  format: number;
  codec: string;
  extension: string;
}

export interface ApiStoreXmediaSet {
  folder: string;
  set: number;
  baseUri: string;
}

export interface ApiStoreXmediaSize {
  sizeItems: ApiStoreXmediaSizeItem[];
  set: number;
}

export interface ApiStoreXmediaSizeItem {
  sizes: ApiStoreXmediaSizeItemSize[];
  format: number;
  clazz: number;
}

export interface ApiStoreXmediaSizeItemSize {
  width: number;
  idSize: number;
  code: string;
  height: number;
}

export type ApiStoreXConf = ApiStoreXConfProperty[] | ApiStoreXConfProperty;

export interface ApiStoreXConfProperty {
  key: string;
  value: string;
}

export enum ApiStoreXConfEnum {
  SEQUENCE_FROM_STOCK_ENABLED = 'SEQUENCE_FROM_STOCK_ENABLED',
  LAST_SIZES_ENABLED = 'LAST_SIZES_ENABLED'
}

export interface ApiPhysicalStoresOptions {
  favouriteStores: boolean;
  lastStores: boolean;
  closerStores: boolean;
  latitude: number;
  longitude: number;
  min: number;
  max: number;
  receiveEcommerce: boolean;
  countryCode?: string;
  radioMax?: number;
}

export interface ApiPhysicalStores {
  lastUsedStores: ApiPhysicalStore[];
  favouriteStores: ApiPhysicalStore[];
  closerStores: ApiPhysicalStore[];
  rueiData: RueiData;
}

export interface ApiPhysicalStore {
  id: string;
  name: string;
  countryName: string;
  countryCode: string;
  state?: string;
  stateCode: string;
  photo: string;
  sections: string;
  area: number;
  latitude: number;
  longitude: number;
  isPickupAllowed: boolean;
  receiveBooking: boolean;
  shippingOnlyForEmployees: boolean;
  addressLines: string[];
  city: string;
  zipCode: string;
  phones: string[];
  receiveStockQuery: boolean;
  restrictedStocksections?: string;
  isBlocked: boolean;
  url: string;
  idStoreType?: number;
  nameStoreType?: string;
  district?: string;
  openingHours?: ApiPhysicalStoreOpeningHours;
}

export interface ApiPhysicalStoreOpeningHours {
  schedule: ApiPhysicalStoreSchedule[];
  openHoliday?: ApiPhysicalStoreOpenHoliday[];
}

export interface ApiPhysicalStoreOpenHoliday {
  days: number[];
  timeStripList: ApiPhysicalStoreTimeStrip[];
}
export interface ApiPhysicalStoreSchedule {
  weekdays: number[];
  timeStripList: ApiPhysicalStoreTimeStrip[];
}

export interface ApiPhysicalStoreTimeStrip {
  initHour: string;
  endHour: string;
}
export interface RueiData {
  StoreLangRUEI: string;
  StoreTypeRUEI: string;
  OperationTypeRUEI: "<!--itxOperationType='rest-service-impl'-->";
  OperationRUEI: "<!--itxOperation='get-physical-store-lists'-->";
  StoreIdRUEI: string;
}
